<template>
  <div :class="['auth-wrapper', _isMobile() ? 'mobile' : '']">
    <div class="login_backgroun">
      <div class="orbit orbit-1"></div>
      <div class="orbit orbit-2"></div>
      <div class="glow"></div>
      <div class="login_content">
        <div class="login_left login_box" v-if="!_isMobile()">
          <div class="left_inner">
            <p class="tag">新疆生产建设兵团技术市场协会 智慧平台</p>
            <h2>
              连接行业资源，<br />
              让协作与发展更高效
            </h2>
            <p class="desc">
              统一门户、多端同步、全流程数字化，让每一次访问都有更好的体验。
            </p>
            <div class="highlights">
              <span>• 会员认证</span>
              <span>• 行业资讯</span>
              <span>• 数据安全</span>
            </div>
          </div>
        </div>
        <div class="login_right login_box">
          <Login />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { TENANT_CONFIG } from "@/store/mutation-types";
import Login from "../components/user/Login";
import { mixinDevice } from "@/utils/mixin.js";

export default {
  mixins: [mixinDevice],
  components: {
    Login,
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.auth-wrapper {
  min-height: 100vh;
}

.mobile {
  .login_content {
    flex-direction: column;
    width: 92%;
    height: auto;
  }

  .login_right {
    width: 100% !important;
  }
}

.login_backgroun {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(130deg, #0e1d41, #162d68 45%, #3c55d3);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .glow {
    position: absolute;
    width: 520px;
    height: 520px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.15), transparent 70%);
    top: 10%;
    right: 15%;
    filter: blur(6px);
    animation: pulse 8s ease-in-out infinite;
  }

  .orbit {
    position: absolute;
    border-radius: 50%;
    border: 1px dashed rgba(255, 255, 255, 0.2);
    animation: spin 18s linear infinite;

    &.orbit-1 {
      width: 680px;
      height: 680px;
      top: 50%;
      left: 10%;
      transform-origin: center;
    }

    &.orbit-2 {
      width: 420px;
      height: 420px;
      top: 20%;
      right: 20%;
      animation-duration: 22s;
    }
  }

  .login_content {
    position: relative;
    width: 960px;
    height: 500px;
    display: flex;
    gap: 32px;
    z-index: 2;
  }

  .login_box {
    width: 50%;
    height: 100%;
    border-radius: 28px;
    backdrop-filter: blur(10px);
    transition: transform 0.4s ease, box-shadow 0.4s ease;

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 25px 50px rgba(15, 27, 65, 0.35);
    }

    .title {
      font-size: 20px;
      color: #1f2d3d;
      font-weight: bold;
      margin-bottom: 15px;
    }
  }

  .login_left {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.05));
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 36px;
    color: #fff;

    .left_inner {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      animation: slideIn 0.8s ease-out;

      .tag {
        font-size: 12px;
        letter-spacing: 2px;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.8);
      }

      h2 {
        font-size: 30px;
        line-height: 1.5;
        margin-top: 10px;
        margin-bottom: 12px;
      }

      .desc {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.85);
      }

      .highlights {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.85);
      }
    }
  }

  .login_right {
    background: #fff;
    border-radius: 28px;
    padding: 28px 32px;
    box-shadow: 0 18px 35px rgba(23, 42, 101, 0.2);
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(0.9);
    opacity: 0.5;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>